export default __webpack_public_path__ + "static/gta_roofing_4-3a18c431b1b6eb4903a860c7c3856dde.jpg";